import { render, staticRenderFns } from "./AssignPlayerModal.vue?vue&type=template&id=c5b21c22&"
import script from "./AssignPlayerModal.vue?vue&type=script&lang=js&"
export * from "./AssignPlayerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports